<template>
  <div>
    <LoadingContainer v-if="loading"/>

    <ListPanel v-else :users="users" :content-article-categories="contentArticleCategories" :portal="portal"/>
  </div>
</template>

<script>
import http from '@/http'
import ListPanel from '../../../../../../../components/Administration/ContentArticles/Panels/List'
import LoadingContainer from '../../../../../../../components/Layout/LoadingContainer'

export default {
  components: {ListPanel, LoadingContainer},

  props: {
    portal: {
      required: true
    }
  },

  data() {
    return {
      users: null,
      contentArticleCategories: null,

      loading: true,
    }
  },

  mounted() {
    this.load()
  },

  methods: {
    load() {
      Promise.all([
        http.get('/api/v2/users'),
        http.get('/api/v2/content-article-categories', {'filter[portal_id]': this.portal.id}),
      ]).then(responses => {

        this.users = responses[0].data.data

        this.contentArticleCategories = responses[1].data.data

        this.loading = false
      })
    },
  }
}
</script>
